import { PointContainerResource, pointContainerResource } from '@witkac/kartamiejska-resources';
import { PointContainer } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł kontenerów
 *
 * @export
 * @class PointContainersModule
 * @extends {EntityModule<PointContainer,PointContainerResource>}
 */
export class PointContainersModule extends EntityModule<PointContainer, PointContainerResource> {
  constructor() {
    super(pointContainerResource);
  }
}

export default new PointContainersModule();
